import React from 'react'
import { ISchool } from '../../interfaces/school.interface'

const CurrencyCodeComponent = (props: { school: ISchool }) => {
  if (!props.school || !props.school.currency_code) {
    return null
  }
  return <>{props.school.currency_symbol || props.school.currency_code}</>
}

export default CurrencyCodeComponent
